import request from '@/utils/request';

const PATH = '/board/category';

export const getBoardCategory = (uid: string) => request({
  url: `${PATH}/${uid}`,
  method: 'get',
});
